import { AdElementText, DateTimeFormat } from '@adflow/types';
import { FormLabel, Radio, RadioGroup, Stack } from '@chakra-ui/react';
import { FC, useCallback } from 'react';
import { useStore } from '../../../../hooks/useStore';

type Props = {
  textElement: AdElementText;
};

export const isDatePresent = (textElement: AdElementText) => {
  if (!textElement.sources[0]) return false;
  return textElement.data.content.includes(`${textElement.sources[0].sourceId}:DATE}`);
};

export const isTextDatePresent = (textElement: AdElementText) => {
  if (!textElement.sources[0]) return false;
  return (
    textElement.data.content.includes(`${textElement.sources[0].sourceId}:DATE}`) &&
    textElement.data.dateDisplayOptions?.isTextFormat
  );
};

const DateFormatControls: FC<Props> = ({ textElement }) => {
  const s = useStore((state) => ({
    displayOptions: state.displayOptions,
    setElementDateDisplayOptions: state.setElementDateDisplayOptions,
  }));

  const dateDisplayOptions: DateTimeFormat | null | undefined =
    textElement.data.dateDisplayOptions || s.displayOptions.dateTimeFormat;

  const handleUpdateDateFormat = useCallback(
    (value: string) => {
      s.setElementDateDisplayOptions(textElement.id, {
        ...dateDisplayOptions,
        isTextFormat: value === 'text',
      });
    },
    [s, dateDisplayOptions, textElement.id],
  );

  return (
    <>
      <Stack direction="row" mb={2}>
        <FormLabel htmlFor="time-format" mb={'0'} style={{ fontVariant: 'all-small-caps' }}>
          Date Display
        </FormLabel>
        <RadioGroup
          value={dateDisplayOptions?.isTextFormat ? 'text' : 'default'}
          id="date-format"
          ml={'auto'}
          mr={0}
          onChange={handleUpdateDateFormat}
        >
          <Stack direction="row">
            <Radio value="default">Classic</Radio>
            <Radio value="text">Text format</Radio>
          </Stack>
        </RadioGroup>
      </Stack>
    </>
  );
};

DateFormatControls.displayName = 'DateFormatControls';

export default DateFormatControls;
